// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__e6Fdv","head":"ProcedureTableInfo_head__18Jgb"};